import { render, staticRenderFns } from "./BaseFinancialStatement.vue?vue&type=template&id=ddf870cc&scoped=true"
import script from "./BaseFinancialStatement.vue?vue&type=script&lang=js"
export * from "./BaseFinancialStatement.vue?vue&type=script&lang=js"
import style0 from "./BaseFinancialStatement.vue?vue&type=style&index=0&id=ddf870cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf870cc",
  null
  
)

export default component.exports